module.exports = __webpack_public_path__ + "img/223-Veka Spectral 5011-Bleu Acier.png";